module.exports = __webpack_public_path__ + "a768e7de/img/note-edit-icon.acae1669.svg";